// O que foi digitado e ainda não foi enviado, por atendimento.
//
// Sem isto o texto vivia só no estado da caixa de mensagem: trocar de conversa,
// recarregar a página ou a conexão cair (o campo some e vira barra de aviso)
// apagava a resposta já escrita.
//
// `localStorage` e não o cookie de preferências: rascunho é texto livre e pode
// ser longo demais para caber num cookie.
const chave = (ticketId) => `rascunho:${ticketId}`;

export const lerRascunho = (ticketId) => {
  if (!ticketId) return "";

  try {
    return window.localStorage.getItem(chave(ticketId)) || "";
  } catch {
    // Navegador com armazenamento bloqueado: sem rascunho, mas sem quebrar a
    // caixa de mensagem.
    return "";
  }
};

export const gravarRascunho = (ticketId, texto) => {
  if (!ticketId) return;

  try {
    if (texto) window.localStorage.setItem(chave(ticketId), texto);
    else window.localStorage.removeItem(chave(ticketId));
  } catch {
    /* idem */
  }
};
